import { render, staticRenderFns } from "./SangomaAIAssistanceModal.vue?vue&type=template&id=d6af5da8&scoped=true&"
import script from "./SangomaAIAssistanceModal.vue?vue&type=script&lang=js&"
export * from "./SangomaAIAssistanceModal.vue?vue&type=script&lang=js&"
import style0 from "./SangomaAIAssistanceModal.vue?vue&type=style&index=0&id=d6af5da8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6af5da8",
  null
  
)

export default component.exports